import { ApolloClient, InMemoryCache } from '@apollo/client';

const client = new ApolloClient({
  uri: 'https://eu-west-2.cdn.hygraph.com/content/clygb0666024607ulr42udrcz/master',
  cache: new InMemoryCache()
});

export default client;